import React from "react";
import { formatarValor } from "../../src/components/OrderTable";

const DetailsTable = ({ order }) => {
  const orderItems = order.order_Items;

  return (
    <div>
      <table className="w-full text-boldGray opacity-90">
        <thead className="w-full table-auto border-collapse">
          <tr className="uppercase bold text-base text-center">
            <th className=" p-4 w-[300px]">Item</th>
            <th className=" p-4 w-[195px]">Quantidade</th>
            <th className=" p-4 w-[195px] ">Valor alvo</th>
            <th className=" p-4 w-[195px]">Valor unitário</th>
            <th className=" p-4 w-[195px]">Total</th>
          </tr>
        </thead>
        <tbody className="space-y-4">
          {orderItems.map((orderItem, index) => (
            <React.Fragment key={index}>
              <tr className="text-center bg-[#E7E7E7] w-full h-[64px]">
                <td className=" py-4 w-[300px]">
                  <div className="line-clamp-2">{orderItem.product.name}</div>
                </td>
                <td className=" py-4 w-[195px]">
                  <div className="line-clamp-2">{orderItem.quantity}</div>
                </td>
                <td className=" py-4 w-[195px]">
                  {formatarValor(orderItem.target_value, "USD")}
                </td>
                <td className=" py-4 w-[195px]">
                  {" "}
                  {formatarValor(orderItem.unit_value, "USD")}
                </td>
                <td className=" py-4 w-[195px]">
                  {formatarValor(
                    orderItem.quantity * orderItem.target_value,
                    "USD"
                  )}
                </td>
              </tr>
              {index !== orderItems.length - 1 && (
                <tr>
                  <td className="h-[6px]"></td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
      <div className="overflow-y-auto  custom-scrollbar mt-2">{/* */}</div>
    </div>
  );
};

export default DetailsTable;
